import "./ProposalHeroModal.scss"
import React from 'react'
import 'swiper/scss';
import "swiper/scss/navigation";
import { Swiper, SwiperSlide } from 'swiper/react'
import ModalContainer from '../../../../../components/modal-container/ModalContainer'
import { Navigation } from "swiper"
import { proposalInnerTypes } from "../ProposalHeroConfig"
import { MEDIA_TYPES_FOR_END_CLIENT } from "../../../../../layouts/proposal-template/ProposalTemplateEndClient.config"
import { useMobileView } from "../../../../../hooks";
import { classNames } from "primereact/utils";
function ProposalHeroModal({ visible, setShowProposalModal, images, type, video }) {
  const isMobile = useMobileView()
  let ModalChild = null
  if (type === MEDIA_TYPES_FOR_END_CLIENT.VIDEO) {
    if (!video || video.length === 0) {
      ModalChild = <h2 className="text-white text-center pt-8 mt-8">No video Link Provided. Please validate data in Curated.</h2>
    }
    else {
      ModalChild = <video className="ProposalHeroModalVideo" controls src={video} ></video>
    }
  }
  if (type === MEDIA_TYPES_FOR_END_CLIENT.IMAGES) {
    if (images.length === 0) {
      ModalChild = <h2 className="text-white text-center pt-8 mt-8">No Images Provided. Please validate data in Curated.</h2>
    }
    else {
      ModalChild = <div className="ProposalSwiper ">
        <Swiper
          grabCursor={true}
          spaceBetween={50}
          slidesPerView={1}
          modules={[Navigation]}
          pagination
          navigation
          loop
        >
          {
            images?.map(({ url }, _idx) => (
            <SwiperSlide className="w-full h-full flex justify-content-center ">
              <img src={url} alt="" className="ProposalHeroModalImage bg-contain bg-no-repeat " />
            </SwiperSlide>
            )
            )
          }
        </Swiper>
      </div>
    }
  }

  return (
    <ModalContainer draggable={false} visible={visible} onHide={setShowProposalModal} className={classNames("ProposalHeroModal z-5 ",{MobileView:isMobile})}>
      <div className="align-items-center flex justify-content-center h-full">
        {ModalChild}
      </div>
    </ModalContainer>
  )
}

export default ProposalHeroModal